// styles
import { PageWrapperStyles } from "./pageWrapper.styles";

const PageWrapper = ({ children }) => {
  return <PageWrapperStyles>{children}</PageWrapperStyles>;
};

export default PageWrapper;
